export enum UserActivityTypes {
  EVENT_VIEW = 'event_view',
  PORTFOLIO_ACCESS = 'portfolio_access',
}
